import styled from "styled-components";
import { Dialog } from "@material-ui/core";
// COMPONENTS
import { PageWrapperBase } from "Components/Website.style";
// CONSTANTS
import { COLORS, FONTS, responsive } from "Styles/Constants";
import { IMAGES } from "Helpers";

export const PageWrapper = styled(PageWrapperBase)`
	color: #fff;
	overflow: hidden;
	min-height: 100vh;
	position: relative;

	.background-image {
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: -1;
		overflow: hidden;
	}

	.overlay-stackrank {
		width: 100%;
		height: 100%;
		z-index: 101;
		display: flex;
		position: absolute;
		align-items: center;
		justify-content: center;
		background-color: rgba(0, 0, 0, 0.3);

		.progress {
			color: #fff;
		}
	}

	.content {
		width: 70%;
		margin: 3% auto 0;
		position: relative;

		${responsive.LAPTOP` margin: 3% 13% 0;`}
		${responsive.TABLET`margin: 3% 8% 0;  width: 78%;`}
	}

	.title-history {
		font-family: ${FONTS.TERTIARY_BOLD};
		font-size: 36px;
		color: #000;
		width: 100%;
		text-align: center;
		padding-top: 5%;
		padding-bottom: 5%;

		${responsive.LAPTOP` padding-top: 10%; margin: 0 auto;  width: 60%;`}
		${responsive.TABLET`padding-top: 13%;`}
	}
`;

export const GridContainer = styled.div`
	flex-wrap: wrap;
	.box {
		width: 25%;
		${responsive.LAPTOP`width:33.33%`}
		${responsive.TABLET`width:35%`}

        .disabled {
			pointer-events: none;
			filter: grayscale(80%);
			cursor: not-allowed;
		}

		.box-content {
			cursor: pointer;
			margin: 0 auto;
			max-width: 300px;
			position: relative;
			transition: 0.3s;
			width: 90%;
			position: relative;
			&:hover {
				transform: scale(1.05);
			}

			${responsive.DISPLAY` max-width : 225px;`}

			.img-container {
				width: 250px;
				height: 300px;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				background-position: center;
				position: relative;
				margin: 0 auto;

				${responsive.DISPLAY`height: 275px; width: 220px;`}
				${responsive.LAPTOP`height: 275px; width: 190px;`}
			}
			.title {
				font-size: 24px;
				padding-top: 17px;
				${responsive.DISPLAY`
                    font-size: 22px;
                    padding-top: 12px;
                `}
				${responsive.LAPTOP`
                    font-size: 18px;
                    padding-top: 12px;
                `}
			}

			.progress-container {
				bottom: 14px;
				padding: 0 10%;
				position: absolute;

				/* ${responsive.DISPLAY` bottom : 16px;`} */
			}
		}
	}
`;

export const ProgressWrapper = styled.div`
	text-align: left;

	.outer {
		background-color: #001d46;
		border: 1px solid rgba(59, 219, 255, 0.3);
		border-radius: 50px;
		width: 80%;
		margin: 0px auto;

		.active {
			border-radius: 50px;
			height: 7px;
			background: #da2323;
			width: ${(props) => props.value}%;
			transition: 0.5s ease;

			${responsive.DISPLAY`height: 6px;`}
		}
	}

	.text {
		width: 80%;
		margin: 3px auto 0px;
	}
`;

export const ScoreboardWrapper = styled.div`
	top: 150px;
	right: 17px;
	width: 220px;
	height: 690px;
	position: absolute;
	background-size: contain;
	background-repeat: no-repeat;
	background-image: url(${IMAGES.ECONOMICS.LEADERBOARD});

	${responsive.DISPLAY`
		width: 188px;
		height: 592px;
	`}

	${responsive.DESKTOP`
		width: 140px;
		height: 440px;
	`}

	.scoreboard-title {
		font-size: 20px;
		text-align: center;
		padding-top: 5px;

		${responsive.DISPLAY`font-size: 18px; `}
	}

	.title {
		text-align: center;
		position: relative;
		z-index: 4;
		color: #fff;

		.image {
			width: 85%;
		}

		.text-container {
			margin-top: -39px;

			${responsive.DISPLAY`
				margin-top: -34px;
			`}

			.text {
				font-size: 18px;

				${responsive.DISPLAY`
					font-size: 14px;
				`}
			}
		}
	}

	.scoreboard-text {
		margin-top: 20px;
		text-align: center;
		font-size: 18px;

		${responsive.DISPLAY` margin-top: 14px;`}
	}

	.people-cards {
		margin-left: 2px;
		margin-top: 44px;

		${responsive.DESKTOP`
			margin-top: 32px;
		`}

		.person {
			width: 100%;
			height: 206px;

			&:nth-child(1) {
				z-index: 3;
			}

			&:nth-child(2) {
				z-index: 2;

				${responsive.DISPLAY`
					margin-top: 10px;
				`}
			}

			&:nth-child(3) {
				z-index: 1;

				${responsive.DISPLAY`
					margin-top: 10px;
				`}
			}

			${responsive.DISPLAY`
				height: 163px;
			`}

			${responsive.DESKTOP`
				height: 118px;
			`}

			.content {
				.image {
					border: 3px solid ${COLORS.SECONDARY};
					border-radius: 10px;
					margin: 0 auto;

					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;

					height: 90px;
					width: 90px;

					${responsive.DESKTOP`
						height: 55px;
    					width: 55px;
					`}
				}

				.name {
					font-size: 20px;
					margin-top: 5px;
					color: #fff;

					${responsive.DISPLAY`
						font-size: 18px;
					`}

					${responsive.DESKTOP`
						font-size: 16px;
					`}
				}

				.score {
					background-color: #0c0d47;
					border-radius: 5px;
					display: inline-block;
					padding: 2px 12px;
					color: #fff;

					${responsive.DISPLAY`
						font-size: 18px;
					`}

					${responsive.DESKTOP`
						font-size: 16px;
					`}
				}
			}
		}
	}
`;
